// change this to recolor every switch in the app
const checkedColor = '#f39c12';

const checkedStyle = {
    '&$checked': {
        color: checkedColor,
        '&:hover': {
            backgroundColor: 'rgba(243, 156, 18, 0.08)'
        }
    },
    '&$checked + $track': {
        backgroundColor: checkedColor
    }
};

export default {
    colorPrimary: checkedStyle,
    colorSecondary: checkedStyle
};
